/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type RemoveLunchHoldMutationInput = {
    calendarId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
    isPaused?: boolean | null | undefined;
    lunchEventId: string;
    orgRelayId: string;
};
export type RemoveLunchHoldMutationVariables = {
    input: RemoveLunchHoldMutationInput;
};
export type RemoveLunchHoldMutationResponse = {
    readonly removeLunchHold: {
        readonly clientMutationId: string | null;
    } | null;
};
export type RemoveLunchHoldMutation = {
    readonly response: RemoveLunchHoldMutationResponse;
    readonly variables: RemoveLunchHoldMutationVariables;
};



/*
mutation RemoveLunchHoldMutation(
  $input: RemoveLunchHoldMutationInput!
) {
  removeLunchHold(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "RemoveLunchHoldMutationPayload",
            "kind": "LinkedField",
            "name": "removeLunchHold",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "RemoveLunchHoldMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "RemoveLunchHoldMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "716864ed810adb5eb9bcb9eae396ea0b",
            "id": null,
            "metadata": {},
            "name": "RemoveLunchHoldMutation",
            "operationKind": "mutation",
            "text": "mutation RemoveLunchHoldMutation(\n  $input: RemoveLunchHoldMutationInput!\n) {\n  removeLunchHold(input: $input) {\n    clientMutationId\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '6c2da5e9f25ed25f0420bd64d0aafbc3';
export default node;
